import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { distributorDetailsApi } from "../../constants/apiConstants";
import request from "../../utils/request";
import { encryptPayload } from "../../utils/encrypt";
import Cookies from "js-cookie";
import toast from "react-hot-toast";

export const profileSettings = createAsyncThunk(
    "profileSettingReducer/profileSettings",
    async ({ dispatch }) => {
       
        
        try {
            const res = await request({
            url: distributorDetailsApi.getDistributorDetails,
            method: "POST",
       });
          return res; 
            }
            catch (error) {
          console.error("distributor details fetch is failed:", error);
          throw error;
        }
       }
)

export const updateDistributerDetails = createAsyncThunk(
  "profileSettingReducer/updateDistributerDetails",
  async ({ data, dispatch }) => {
      try {
          const res = await request({
          url: distributorDetailsApi.updateDistributerDetails,
          method: "POST",
          data: data,
     });
        // Dispatch success response
        dispatch(updateDistributerDetailsRes(res));
        if(res?.responseCode === 200){
          toast.success("Profile details updated successfully");
          dispatch(profileSettings({dispatch})); 
        } else {
          toast.error("Failed to update Profile details");
        }
        return res; 
      }catch (error) {
        console.error("distributor details update failed:", error);
        throw error;
      }
     }
)

export const updateDistributerPassword = createAsyncThunk(
  "profileSettingReducer/updateDistributerPassword",
  async ({ data, dispatch, setError, navigate }) => {
      try {
          // Encrypt the payload
          const encryptedPayload = encryptPayload(data);
          const res = await request({
          url: distributorDetailsApi.updateDistributerPassword,
          method: "POST",
          data: {data: encryptedPayload},
     });
        // Dispatch success response
        dispatch(updateDistributerPasswordRes(res));
        if(res?.responseCode === 200){
          toast.success("Password updated successfully");

          // Logout on successful response
          Cookies.set("loginStatus", false, { path: "", expires: 365 });
          Cookies.remove("authToken");
          Cookies.remove("refreshToken");
          navigate("/signin");
        } else {
          toast.error("Failed to update password");
          setError("oldPassword", {message: res?.response});
        }
        return res; 
      }catch (error) {
        console.error("distributor password update failed:", error);
        throw error;
      }
     }
)

const profileSettingSlice = createSlice({
     name: "profileSettings",
     initialState: {
       getDistributorDetailReq: null,
       isGetDistributorDetailLoading: false,
       updateDistributerDetails: null,
       updateDistributerPassword: null,
     },
     reducers: {
       profileSettingsRes: (state, action) => {
          state.getDistributorDetailReq = action.payload;
       },
      updateDistributerDetailsRes: (state, action) => {
        state.updateDistributerDetails = action.payload;
      },
      updateDistributerPasswordRes: (state, action) => {
        state.updateDistributerPassword = action.payload;
      },
     },
     extraReducers: (builder) => {
       builder
         .addCase(profileSettings.pending, (state) => {
          state.isGetDistributorDetailLoading = true;
         })
         .addCase(profileSettings.fulfilled, (state,action) => {
          state.isGetDistributorDetailLoading = false;
          state.getDistributorDetailReq = action.payload
         })
         .addCase(profileSettings.rejected, (state) => {
          state.isGetDistributorDetailLoading = false;
         });
     },
   });

      export const { profileSettingsRes, updateDistributerDetailsRes, updateDistributerPasswordRes } = profileSettingSlice.actions;
      export default profileSettingSlice.reducer;